// import React from 'react';
import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['accountType', 'accountSubType', 'salesChannel', 'marketSegment']);
  let newData = dataCreate.replace('{embrixData: ', '');
  newData = `${newData.substring(0, newData.length - 1)}`;
  const createCollectionProfiles = `createCollectionProfiles(input: ${newData})`;
  return gql`
  mutation {
    ${createCollectionProfiles} {
      id
    }
  }
`;
};
